import { CurrencyPipe, LocationStrategy, HashLocationStrategy, registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ApplicationConfig, provideZoneChangeDetection, isDevMode, LOCALE_ID } from "@angular/core";
import { environment } from "../environments/environment";
import { provideRouter } from "@angular/router";
import { provideServiceWorker } from "@angular/service-worker";
import { routes } from "./app.routes";
import { NgApexchartsModule } from "ng-apexcharts";
import { authInterceptor } from "./core/interceptors/auth-interceptor";
import { cacheInterceptor } from "./core/interceptors/cache.interceptor";
import { BranchPipe } from "./shared/pipes/branch.pipe";
import { ChangeDotMoneyPipe } from "./shared/pipes/changeDotMoney.pipe";
import { CnpjPipe } from "./shared/pipes/cnpj.pipe";
import { CpfPipe } from "./shared/pipes/cpf.pipe";
import { MePipe } from "./shared/pipes/me.pipe";
import { getPtBrPaginatorIntl } from "./core/components/paginator/paginator-intl-pt";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { MY_DATE_FORMATS } from "./shared/components/formy/components/inputy/date-format";
import localePt from '@angular/common/locales/pt';

import * as moment from 'moment';
import 'moment/locale/pt-br';

registerLocaleData(localePt);
moment.locale('pt-br');

export const appConfig: ApplicationConfig = {
  providers: [
    CnpjPipe,
    BranchPipe,
    MePipe,
    CpfPipe,
    CurrencyPipe,
    ChangeDotMoneyPipe,
    provideHttpClient(withInterceptors([authInterceptor, cacheInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode() || environment.mode === 'test',
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: MatPaginatorIntl, useValue: getPtBrPaginatorIntl() },
    NgApexchartsModule,

    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
};
